import InlineSVG from "react-inlinesvg";
import styled from "styled-components/macro";

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--danger-color);
  text-align: left;
  text-wrap: pretty;
  line-height: 1.4;
  padding: 8px 18px 8px 12px;
  border-radius: 8px;
  border: 1px solid var(--grey-3);
  margin-left: 15px;

  svg {
    flex-shrink: 0;
    path {
      fill: var(--danger-color);
    }
  }
`;

export const InlineWarning = ({ text, children, className }) => {
  return (
    <Container className={className}>
      <InlineSVG src="/assets/warning-square.svg" />
      {text}
      {children}
    </Container>
  );
};

export default InlineWarning;
